import { useCompany } from "@/context/CompanyContext";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function RequireCompany({ children }) {
  const { active, companies, loading } = useCompany();
  if (loading) return <div className="p-6 text-sm text-gray-500">Loading…</div>;
  if (!active) {
    return (
      <div className="p-10 max-w-md mx-auto text-center">
        <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-700 flex items-center justify-center mx-auto mb-3">
          <Building2 className="w-6 h-6" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">
          {companies.length ? "Select a company" : "Create your first company"}
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Companies hold your books of accounts. Switch using the header dropdown.
        </p>
        <Button asChild className="mt-4 bg-blue-700 hover:bg-blue-800" data-testid="create-first-company">
          <Link to="/companies">Go to Companies</Link>
        </Button>
      </div>
    );
  }
  return children;
}
